import React from 'react'
import { useNavigate } from 'react-router-dom'
import Text from '../../components/atoms/Text'
import MobileLayout from '../../components/MobileLayout'
import ZydusHeader from '../../components/molecules/ZydusHeader'
import VKPodcastImage1 from '../../assets/images/vk_podcast_thumbnail_1.webp'
import VKPodcastImage2 from '../../assets/images/vk_podcast_thumbnail_2.webp'

import { PODCAST_DATA } from '../../constants/podcastData'

const PODCAST_LIST_THUMBNAILS = {
  'E_-yVJsULZk':
    'https://framerusercontent.com/images/92IhJ8Cse6OyIApJiT2en3zf3U.png',
  '9OoY53Ngduk':
    'https://framerusercontent.com/images/zf2KWW6W7C0fighUNGzuMJHPGOc.png',
  BOXB01O1LmU:
    'https://framerusercontent.com/images/WjG7D8ZVND0aKxVGbGByoeGWAd4.png',
  bXLqMedwz_I:
    'https://framerusercontent.com/images/nXABXDKOXe1YBt8RUPIORR9Wg.png',
  MHSVDWZnXqQ: VKPodcastImage1,
  qnYpXHOVYY0: VKPodcastImage2,
}

const PodcastsPage = ({ onSelectPodcast = () => {} }) => {
  const navigate = useNavigate()

  const handlePodcastClick = (videoKey) => {
    onSelectPodcast()
    navigate(`/podcast/${videoKey}`)
  }

  const getListThumbnail = (podcast) => {
    return PODCAST_LIST_THUMBNAILS[podcast.videoKey] || podcast.image
  }

  return (
    <MobileLayout>
      <ZydusHeader />

      {/* Mobile layout */}
      <div className="p-4 mt-14 lg:hidden">
        <Text variant="display" size="large">
          Podcasts
        </Text>
        <div className="flex flex-col gap-5 mt-8">
          {PODCAST_DATA.map((podcast) => (
            <div
              key={podcast.videoKey}
              className="p-3 shadow-[_0px_0px_12px_0px_#00000014] rounded-xl flex justify-between items-center gap-6 cursor-pointer"
              onClick={() => handlePodcastClick(podcast.videoKey)}
            >
              <div className="w-[60%]">
                <Text
                  tag="p"
                  variant="title"
                  size="large"
                  className={'!font-exo line-clamp-2 !text-[#3D4854]'}
                >
                  {podcast.title}
                </Text>
                <div className="flex gap-1 items-center">
                  <Text variant="body" size="small" className="!text-[#A2A2A8]">
                    {podcast.date}
                  </Text>
                  <span className="!text-[#E2E2EA] font-extralight">|</span>
                  <Text variant="body" size="small" className="!text-[#A2A2A8]">
                    {podcast.time}
                  </Text>
                </div>
              </div>
              <div className="w-[40%]">
                <img
                  src={getListThumbnail(podcast)}
                  className="w-full"
                  alt={podcast.title}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop layout */}
      <div className="hidden lg:block p-8 pt-32">
        <Text variant="display" size="large" tag="p">
          Life Ka Filter Podcasts
        </Text>
        <Text variant="body" size="large" tag="p" className="mt-3 max-w-2xl">
          A podcast series that filters out the noise and brings you real,
          heartfelt conversations around Chronic Kidney Disease (CKD)
        </Text>
        <div className="grid grid-cols-2 gap-5 mt-8">
          {PODCAST_DATA.map((podcast) => (
            <div
              key={podcast.videoKey}
              className="p-4 shadow-[0px_0px_12px_0px_#00000014] rounded-xl flex items-center gap-5 cursor-pointer hover:shadow-md transition-shadow"
              onClick={() => handlePodcastClick(podcast.videoKey)}
            >
              <div className="flex-1 min-w-0">
                <Text
                  tag="p"
                  variant="title"
                  size="large"
                  className="!font-exo line-clamp-3 !text-[#3D4854]"
                >
                  {podcast.title}
                </Text>
                <div className="flex gap-1 items-center mt-1">
                  <Text variant="body" size="small" className="!text-[#A2A2A8]">
                    {podcast.date}
                  </Text>
                  <span className="!text-[#E2E2EA] font-extralight">|</span>
                  <Text variant="body" size="small" className="!text-[#A2A2A8]">
                    {podcast.time}
                  </Text>
                </div>
              </div>
              <div className="w-[30%]">
                <img
                  src={getListThumbnail(podcast)}
                  className="w-full"
                  alt={podcast.title}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </MobileLayout>
  )
}

export default PodcastsPage
